export enum NavigationReason {
  scroll = "scroll",
  button = "button",
}

export type SetPage = (pageId: string, navigationReason: NavigationReason) => void;
